// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //apiUrl: 'http://localhost:8000/api/v1',
  //adminApiUrl: 'http://localhost:8000/api/admin/v1',
  apiUrl: 'https://mp-dev.michpro.store/api/v1',
  adminApiUrl: 'https://mp-dev.michpro.store/api/admin/v1',
  appUrl: 'https://michpro.store/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
